import { PropsWithChildren, useEffect, useCallback } from 'react'
import { useGetUserToken } from '@/modules/Auth'
import { useAuthStore } from '@/store/auth-store'
import { useLocation } from 'react-router-dom'
import { ROUTES } from '.'
import { useNavigate } from 'react-router-dom'
import { Role } from '@/types/auth'

export const AuthorizedRedirect = ({ children }: PropsWithChildren) => {
    const { accessToken } = useAuthStore()
    const { role } = useAuthStore()
    const { pathname } = useLocation()
    const navigate = useNavigate()
    useGetUserToken()

    const navigateToHome = useCallback(() => {
        if (role === Role.PerformanceManager) {
            navigate(ROUTES.AREAS)
        } else {
            navigate(ROUTES.HOME)
        }
    }, [navigate, role])

    useEffect(() => {
        if (pathname === ROUTES.LOGIN && accessToken !== null) {
            navigateToHome()
        }
    }, [pathname, accessToken, role, navigateToHome])

    return children
}
